export default "__VITE_ASSET__DyXpU9Qu__"